import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFirebase } from "../../../context/FirebaseContext";
import { useLanguage } from "../../../context/LanguageContext";
import { getHomePageContent } from "../../../firebase/settings-functions.js";
import "./StorySection.css";
import { DEFAULT_STORE_ID } from "../../../firebase/firebase";

const StorySection = () => {
  const [storyContent, setStoryContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const { language } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStoryContent = async () => {
      if (!DEFAULT_STORE_ID) {
        setLoading(false);
        return;
      }

      // 1. Check Session Cache (Language-specific)
      const cacheKey = `homeContent_${DEFAULT_STORE_ID}_${language}`;
      const cachedData = sessionStorage.getItem(cacheKey);

      if (cachedData) {
        const parsed = JSON.parse(cachedData);
        if (parsed.storySection) {
          setStoryContent(parsed.storySection);
          setLoading(false);
          return;
        }
      }

      try {
        const homePageData = await getHomePageContent(DEFAULT_STORE_ID, language);

        if (homePageData) {
          // Update Cache
          sessionStorage.setItem(cacheKey, JSON.stringify(homePageData));

          if (homePageData.storySection) {
            setStoryContent(homePageData.storySection);
          }
        }
      } catch (error) {
        console.error("Error fetching story content:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStoryContent();
  }, [language]);

  const handleButtonClick = () => {
    if (storyContent.buttonLink) {
      if (storyContent.buttonLink.startsWith("http")) {
        // External link
        window.open(storyContent.buttonLink, "_blank");
      } else {
        // Internal route
        navigate(storyContent.buttonLink);
      }
    }
  };

  if (loading) {
    return (
      <section className="story-section loading">
        <div className="loading-spinner"></div>
      </section>
    );
  }

  // Don't render empty section if no data
  if (!storyContent) return null;

  return (
    <div>
      {/* Story Section */}
      <section className="story-section">
        <h2>{storyContent.title}</h2>
        <p>{storyContent.description}</p>
        {storyContent.buttonText && (
          <button
            className="discover-btn"
            onClick={handleButtonClick}
          >
            {storyContent.buttonText}
          </button>
        )}
      </section>
    </div>
  );
};

export default StorySection;
